import {
    TouchableOpacity,
    View
} from "react-native";
import type StatCardProps from "./type";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitTheme,
    Sticker,
    Text
} from "ncore-ui-kit";
import {
    ChevronRightIcon
} from "lucide-react-native";

const StatCard = ({
    icon: IconComponent,
    badgeText,
    subStats,
    onPress,
    title,
    value
}: StatCardProps) => {
    const {
        radiuses,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext();

    return <TouchableOpacity
        style={[
            stylesheet.container,
            {
                backgroundColor: colors.project.brandWhite,
                borderRadius: radiuses.md,
                padding: spaces.spacingLg,
                gap: spaces.spacingMd
            }
        ]}
        activeOpacity={0.7}
        onPress={onPress}
    >
        <View
            style={stylesheet.cardHeader}
        >
            <View
                style={stylesheet.headerInfo}
            >
                <Text
                    variant="labelLargeSize"
                    color="mid"
                >
                    {title}
                </Text>
                <Text
                    style={{
                        marginTop: spaces.spacingXs
                    }}
                    variant="headlineMediumSize"
                >
                    {String(value)}
                </Text>
            </View>
            <View
                style={[
                    stylesheet.iconContainer,
                    {
                        backgroundColor: colors.content.container.subtle,
                        borderRadius: radiuses.full,
                        padding: spaces.spacingSm
                    }
                ]}
            >
                <IconComponent
                    color={colors.content.text.high}
                    size={22}
                />
            </View>
        </View>
        {
            subStats && subStats.length > 0 ?
                <View
                    style={[
                        stylesheet.subDetailsContainer,
                        {
                            paddingTop: spaces.spacingSm
                        }
                    ]}
                >
                    {
                        subStats.map((item, index) => {
                            return <View
                                style={stylesheet.subDetailItem}
                                key={`${item.label}-${index}`}
                            >
                                <Text
                                    variant="labelSmallSize"
                                    color="low"
                                >
                                    {item.label}
                                </Text>
                                <Text
                                    variant="titleSmallSize"
                                >
                                    {String(item.value)}
                                </Text>
                            </View>;
                        })
                    }
                </View>
            :
                null
        }
        <View
            style={stylesheet.footerContainer}
        >
            {
                badgeText ?
                    <Sticker
                        title={badgeText}
                        size="small"
                        type="info"
                    />
                :
                    null
            }
            <ChevronRightIcon
                color={colors.content.text.low}
                size={16}
            />
        </View>
    </TouchableOpacity>;
};
export default StatCard;
